import angular from 'angular';


angular.module('vrm.components').service('AlarmsCacheService', AlarmsCacheService);

/* @ngInject */
function AlarmsCacheService(
    $rootScope,
    ApiService,
) {
    const service = {
        cachedAlarms: [],
        fetchAlarms() {
            return ApiService.call2('/installations/alarms-overview').then(response => {
                return (this.cachedAlarms = response.data.alarms);
            });
        },
        clear() {
            this.cachedAlarms = [];
        },
    };

    $rootScope.$on('logout', () => {
        service.clear();
    });

    return service;
}
